import React from 'react';
import c from 'classnames';

import { Button, Stack, Typography } from '@lyearn/ui';

import { maxW264, maxW364 } from './styles';
import { EmptyStateProps } from './types';

const EmptyState: React.FC<EmptyStateProps> = (props) => {
  const {
    secondaryAction,
    primaryAction,
    description,
    Icon,
    title,
    className,
    width = 'wide',
    size = 'large',
    icon,
    doNotUseFooter,
  } = props;

  const renderIcon = () => {
    if (icon) {
      return icon;
    }

    if (Icon) {
      return (
        <Icon
          data-testid="empty-state-icon"
          fillColorToken="icon-placeholder"
          height={32}
          width={32}
        />
      );
    }

    return null;
  };

  const { label, ...rest } = primaryAction || {};

  return (
    <Stack
      alignItems="center"
      className={c(className, width === 'narrow' ? maxW264 : maxW364, 'mx-auto')}
      direction="col"
      justifyContent="center">
      {renderIcon()}
      <Typography
        className="mt-12 text-center"
        color="text-text-paragraph"
        variant={size === 'large' ? 'label-01' : 'label-02'}>
        {title}
      </Typography>
      <Typography
        className="mt-8 text-center "
        color="text-text-secondary"
        variant={size === 'large' ? 'body-short-01' : 'body-short-02'}>
        {description}
      </Typography>
      {primaryAction || secondaryAction ? (
        <Stack
          alignItems="center"
          className="mt-32 space-s-8"
          direction="row"
          justifyContent="center">
          {secondaryAction ? (
            <Button
              StartIcon={secondaryAction.StartIcon}
              alignment="center"
              appearance="secondary"
              disabled={secondaryAction.disabled}
              loading={secondaryAction.loading}
              shape="pill"
              size="small"
              variant="outlined"
              onClick={secondaryAction.onClick}>
              {secondaryAction.label}
            </Button>
          ) : null}
          {primaryAction ? (
            <Button
              appearance="secondary"
              disabled={primaryAction.disabled}
              loading={primaryAction.loading}
              shape="pill"
              size="small"
              variant={secondaryAction ? 'filled' : 'outlined'}
              {...rest}>
              {label}
            </Button>
          ) : null}
        </Stack>
      ) : null}
      {doNotUseFooter}
    </Stack>
  );
};

export default EmptyState;
